import { render } from "./arrow_left.svg?vue&type=template&id=435bddec"
const script = {}
script.render = render

export default script